import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetLastProductVersionsUseCaseInterface } from 'domain/usecases';

import { HttpStatusCode } from '../../protocols/http';

export class RemoteGetLastProductVersions
  implements GetLastProductVersionsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetLastProductVersionsUseCaseInterface.Params,
  ): Promise<GetLastProductVersionsUseCaseInterface.Result> {
    const requestUrl = `${this.url}?frontApp=${params.frontApp}&env=${params.env}`;
    const httpResponse = await this.httpClient.request({
      url: requestUrl,
      method: 'get',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
